<template>
  <el-dialog
    v-model="isShow"
    :title="formTitle"
    custom-class="simple-template-dialog"
    :width="getWidth"
    top="0"
    @close="confirmBtn"
  >
    <slot/>
    <slot name="content">
      <div>我是子组件的内容</div>
    </slot>

    <template v-if="isShowFooter" #footer>
      <el-button class="confirm-button" @click="confirmBtn(true)">{{ confirmButton }}</el-button>
    </template>
  </el-dialog>
</template>
<script>

import "@assets/css/mydialog.scss";

export default {
  name: "MyDialog",
  props: {
    confirmButton: {
      type: String,
      default: "关闭"
    },
    dialogCarted: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 0
    },
    isShowFooter: {
      type: Boolean,
      default: true,
    },
    formTitle: {
      type: String,
      default: ""
    }
  },
  emits: ["confirmOk"],
  data() {
    return {
      isShow: false
    };
  },

  computed: {
    getWidth() {
      return this.width + "px";
    },
  },
  watch: {
    dialogCarted: {
      handler(val) {
        this.isShow = val;
      },
      immediate: true
    }
  },

  methods: {
    confirmBtn(isConfirm) {
      this.$emit("confirmOk", isConfirm);
    },
  },
};
</script>
<style scoped>
</style>
